import { render, staticRenderFns } from "./Contracts.vue?vue&type=template&id=f08891a6&scoped=true&"
import script from "./Contracts.vue?vue&type=script&async=true&lang=js&"
export * from "./Contracts.vue?vue&type=script&async=true&lang=js&"
import style0 from "./Contracts.vue?vue&type=style&index=0&id=f08891a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f08891a6",
  null
  
)

export default component.exports